import mutations from './healthPartnerManagerReport.mutations'
import actions from './healthPartnerManagerReport.actions'
import getters from './healthPartnerManagerReport.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
